import { ChevronDownIcon } from 'lucide-react';
import type { ComponentProps } from 'react';
import { cn } from '../../../common/functions/cn';

type SelectProps = Omit<ComponentProps<'select'>, 'size'> & {
  size?: 'sm' | 'default';
};

const Select = ({ className, size = 'default', ...props }: SelectProps) => {
  return (
    <div
      className={cn('group/select relative w-fit has-[select:disabled]:opacity-50', className)}
      data-slot="select-wrapper"
      data-size={size}
    >
      <select
        data-slot="select"
        data-size={size}
        className={cn(
          'w-full min-w-0 select-none appearance-none truncate pr-9 pl-2.5',
          size === 'sm' ? 'h-7' : 'h-8',
          'text-sm',
          'rounded-md border border-input bg-background outline-none',
          'selection:bg-primary selection:text-primary-foreground',
          'placeholder:text-muted-foreground [&:has(option[value=""]:checked)]:text-muted-foreground',
          'focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/50',
          'disabled:pointer-events-none disabled:cursor-not-allowed',
          'aria-invalid:border-error aria-invalid:ring-2 aria-invalid:ring-error/20',
          'aria-invalid:focus-visible:border-error aria-invalid:focus-visible:ring-error/60'
        )}
        {...props}
      />
      <ChevronDownIcon
        className="pointer-events-none absolute top-1/2 right-2 size-4 -translate-y-1/2 select-none text-muted-foreground"
        data-slot="select-icon"
      />
    </div>
  );
};

const SelectOption = ({ className, ...props }: ComponentProps<'option'>) => {
  return <option data-slot="select-option" className={cn('bg-background text-foreground', className)} {...props} />;
};

const SelectOptGroup = ({ className, ...props }: ComponentProps<'optgroup'>) => {
  return <optgroup data-slot="select-optgroup" className={cn('bg-background text-foreground', className)} {...props} />;
};

export { Select, SelectOptGroup, SelectOption };
